// extracted by mini-css-extract-plugin
export default {"GridSelectorInput_defaultMargin":"ActRevaluationItemModal_GridSelectorInput_defaultMargin__WLc4x"};